module.exports = __webpack_public_path__ + "img/logo-mini-color.b7748052.png";